<template>
  <p :style="styles" :class="[className , classes]" @input="updateComponent" v-html="$t(html)"></p>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "paragraph",
  props: {
    text: {
      type: String,
      default: "Empty paragraph"
    },
    grid: {
      type: Object,
      default: () => ({
        backgroundColor: "#fff"
      })
    },
    actions: {
      type: Array
    },
    variables: Object,
    className: String,
    classes: Array,
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      cssString: ""
    };
  },
  computed: {
    html () {
      let result = this.text;
      if (this.variables) {
        for (const variable in this.variables) {
          let value = this.$store.state[variable];
          result = this.$t(this.text, [value])
        }
      }
      return result;
    }
  },
  methods: {
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000),
    triggerActions () {
      if (this.actions) {
        this.actions.forEach(action => {
          this.$store.dispatch(action, { val: 123 });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  outline: 0;
}
.heading {
  font-size: 34px;
  line-height: 40px;
  font-weight: bold;
  letter-spacing: 0px;
  color: var(--text-color-1);
  opacity: 1;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 29px;
  }

  &-emp {
    color: var(--emp-color);
  }

  &-par {
    color: var(--par-color);
  }
}
.subHeading {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: var(--text-color-2);
  opacity: 1;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
  }
}
</style>